var _desc, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilverShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "63px",
    height: "87px",
    viewBox: "0 0 63 87",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/Silver-shield") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Silver-shield",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SILVER-shield",
    transform: "translate(1.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.8349754,83.8716883 C49.5654297,74.1335164 57.8962398,58.052348 58.9240723,51.0101588 C60.6339245,40.7510122 60.3731527,20.3979221 56.1305419,11.1358442 C45.6591797,17.1072443 37.8504926,10.60282 30.7229064,6.25397032 C21.773399,13.1707421 13.5091133,17.3440074 3.84236453,10.530705 C2.58719212,24.1165492 -1.26733398,40.076527 1.86674877,51.7334694 C6.35205078,68.3899592 18.2992611,76.2337662 30.8349754,83.8716883 Z",
    id: "SHADOW",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#000000",
    opacity: 0.2,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.8349754,77.8716883 C49.5654297,68.1335164 57.8962398,52.052348 58.9240723,45.0101588 C60.6339245,34.7510122 60.3731527,14.3979221 56.1305419,5.13584416 C45.6591797,11.1072443 37.8504926,4.60282004 30.7229064,0.253970315 C21.773399,7.17074212 13.5091133,11.3440074 3.84236453,4.53070501 C2.58719212,18.1165492 -1.26733398,34.076527 1.86674877,45.7334694 C6.35205078,62.3899592 18.2992611,70.2337662 30.8349754,77.8716883 Z",
    id: "STROKE_670baedd-cb34-4dae-a153-24fd318e1753",
    stroke: "#000000",
    strokeWidth: 2.5,
    fill: "#BAD6DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6308785,11.2289916 C58.3671875,37.6734223 55.7513637,59.3250948 31.0070794,71.4879406 C3.57727053,56.9373362 2.50115605,39.4243886 7.64365002,11.2738021 C15.5129355,14.6537929 25.1090832,13.4840721 31.0070794,6.3239968 C37.076492,11.483604 46.3171093,15.0282805 53.6308785,11.2289916 Z",
    id: "STROKE_1bb2f6e9-6c2d-4ce7-9b22-3ad4d8eb5f76",
    stroke: "#91BECA",
    strokeWidth: 1.5,
    fill: "#D2E5E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0070794,71.4879406 C3.57727053,56.9373362 2.50115605,39.4243886 7.64365002,11.2738021 C15.5129355,14.6537929 25.1090832,13.4840721 31.0070794,6.3239968",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverShield);
export default __webpack_public_path__ + "static/media/silverShield.e926de2841bffce256ed658473fd4a2a.svg";
export { ForwardRef as ReactComponent };